import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/pro-regular-svg-icons";
import axios from "axios";

const PropertyInterestIndicator = () => {
    const current_booking = useSelector((state) => state.booking.current_booking);
    const [leadSources, setLeadSources] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (current_booking?.id) {
            fetchLeadSources();
        }
    }, [current_booking?.id]);

    const fetchLeadSources = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}bookings/${current_booking.id}/lead-sources`);
            if (response.data.success) {
                setLeadSources(response.data.lead_sources || []);
            }
        } catch (error) {
            console.error("Error fetching lead sources:", error);
        } finally {
            setLoading(false);
        }
    };

    // Only show for QP
    if (process.env.REACT_APP_COLOUR !== "QP") {
        return null;
    }

    // Don't show if no lead sources or still loading
    if (loading || !leadSources || leadSources.length === 0) {
        return null;
    }

    // Get unique property names
    const propertyNames = [...new Set(leadSources.map(ls => ls.source_property_name || ls.property_name).filter(Boolean))];
    
    // Get unique source systems (fallback when no property)
    const sourceSystems = [...new Set(leadSources.map(ls => ls.source_system).filter(Boolean))];

    // Don't show if no property names AND no source systems
    if (propertyNames.length === 0 && sourceSystems.length === 0) {
        return null;
    }

    return (
        <div className="flex-none px-4 py-2 bg-blue-50 border-t border-blue-200">
            <div className="flex items-center gap-2 text-xs text-blue-700">
                <FontAwesomeIcon icon={faBuilding} className="text-blue-600" />
                <span className="font-medium">
                    {propertyNames.length > 0 ? "Property Interest:" : "Source System:"}
                </span>
                <div className="flex flex-wrap gap-2">
                    {propertyNames.length > 0 ? (
                        propertyNames.map((name, index) => (
                            <span key={index} className="px-2 py-0.5 bg-blue-100 text-blue-800 rounded-full font-medium">
                                {name}
                            </span>
                        ))
                    ) : (
                        sourceSystems.map((system, index) => (
                            <span key={index} className="px-2 py-0.5 bg-purple-100 text-purple-800 rounded-full font-medium">
                                {system}
                            </span>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default PropertyInterestIndicator;
